<template>
    <div>
        <data-table
            v-if="tableLoaded"
            :exportable="this.$store.getters.hasPermission(['project_current_welds'], ['read'])"
            title=""
            :rows="getData.rowData"
            :columns="columnData"
            :perPage="perPage"
            :rowsCount="rowsCount"
            :currentPage="currentPage"
            :pageCount="pageCount"
            :rowChangeSelectOptions="rowChangeSelectOptions"
            @changePage="changePage"
            @searchEvent="searchEvent"
            @orderByEvent="orderByEvent"
            @rowClickCheck="onClickCheck"
            @rowChangeSelect="rowChangeSelect"
            @exportButtonClick="onExportButton"
        >
        </data-table>

        <b-btn
            v-if="this.$store.getters.hasPermission(['project_ndt_welds'], ['read'])"
            class="btn btn-dark mt-3" 
            @click="goToNdtWelds" 
        >
            <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.go_to.go_to_ndt_welds')}}
        </b-btn>

        <b-btn 
            v-if="this.$store.getters.hasPermission(['project_ndt_welds'], ['read']) && archived == 0"
            class="btn btn-success mt-3 ml-2" 
            @click="onShowRequests"
        >
            <i class="fa fa-eye" aria-hidden="true"></i> {{$t('general.welding.dashboard_1.current_welds_current.show_requests.title')}}
        </b-btn>

        <weld-requests
            ref="weldRequests"
            :testingTypes="current_weld_special_columns"
            @onLoadMainTable="onLoadTable"
        >
        </weld-requests>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import miniToastr from 'mini-toastr';
import WeldRequests from '@/components/pages/project/welding/current_welds/weld_requests/weld_requests.vue';

export default {
    name: 'current_welds_table',
    components: {
        DataTable,
        WeldRequests,
    },
    props: {
        archived: {
            type: Number,
            required: true,
        },
        rowChangeSelectOptions: {
            type: Object,
            default () {
                return null;
            },
        },
        columnData: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            tableName: 'current_weld',
            tableNameTranslated: Vue.i18n.translate('general.welding.weld.title_modal'),
            row: null,

            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',

            getData: {
                rowData: [],
            },
        }
    },
    mounted() {
        if (!this.isArchived()) {
            this.onLoadTable();
        }
    },
    computed: {
        current_weld_special_columns: {
            get: function () {
                let current_weld_special_columns = this.$store.getters.getCurrentWeldSpecialColumns;

                return current_weld_special_columns;
            }
        }
    },
    watch: {
        current_weld_special_columns: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            http.route(this.tableName + '?project_id=' + this.$route.params.id + '&filters[archived]=' + this.archived + '&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get()
            .then(response => {
                if (!response.isError) {
                    this.perPage     = response.pagination.limit;
                    this.rowsCount   = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount   = response.pagination.totalPages;
                    var data = response.data;
                    data.forEach((field, index) => {
                        if (field.inspection == null) {
                            field.inspection = { 
                                'value': '' 
                            };
                        }

                        if (field.spool == null) {
                            field.spool = { 
                                'spool_no': '' 
                            };
                        }

                        if (field.project_setting == null) {
                            field.project_setting = { 
                                'value': '' 
                            };
                        }

                        if (field.weld_material == null) {
                            field.weld_material = { 
                                'value': '' 
                            };
                        }

                        if (field.welder1 == null) {
                            field.welder1 = { 
                                'fullname': '' 
                            };
                        }

                        if (field.welder2 == null) {
                            field.welder2 = { 
                                'fullname': '' 
                            };
                        }
                    });

                    this.getData.rowData = data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onClickCheck (row, index, column) {
            let tmp_value = (row[column.toString()] == null || row[column.toString()] == 0) ? 1 : 0;

            let put_data = {
                project_id: this.$route.params.id, 
                weld_id:    row.id,
            };

            put_data[column] = tmp_value;

            //Checkboxes are only to be updated for the non-archived rows
            if (this.archived == 0) {
                http.route(this.tableName + '/' + row.id + '/update_checkbox').patch(put_data, true)
                .then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        row[column.toString()] = tmp_value;
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }

                    this.onLoadTable();
                });
            }
            
            //Closed can be updated from both tables
            if (column == 'current_weld_closed') {
                http.route(this.tableName + '/' + row.id + '/update_closed').patch(put_data, true)
                .then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        row[column.toString()] = tmp_value;
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }

                    this.onLoadTable();
                });
            }
        },
        rowChangeSelect (row, index, column, column_name, value) {
            var put_data = {
                project_id: this.$route.params.id,
            };

            switch (column_name) {
                case 'inspection_id':
                    put_data[column_name] = value;

                    Object.keys(put_data).forEach(key => {
                        if (put_data[key] === '') {
                            put_data[key] = null;
                        }
                    });

                    http.route(this.tableName + '/' + row.id + '/update_inspection').patch(put_data, true)
                    .then(response => {
                        if (!response.isError) {
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        } else {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        }
                    });
                break;
            }
        },
        onShowRequests () {
            if (!this.isArchived()) {
                this.$refs.weldRequests.showModal();
            }
        },
        isArchived () {
            return (this.archived == 1);
        },
        goToNdtWelds () {
            this.$router.push({name: 'ndt_welds'});
        },
        onExportButton() {
            http.route(this.tableName + '?project_id=' + this.$route.params.id + '&filters[archived]=' + this.archived).exportExcel({
                export: 1,
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType
            }, 'current_welds.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.exported'));
                }
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/welding/current_welds/current_welds_table.vue